<template>
     <front-layout title="Publicações">
        <!-- SEARCH BOX GOES HERE -->
        <div class="container mx-auto pt-40 px-4">
            <div v-if="posts.length">
                <div class="container mx-auto py-20">
                    <div class="grid lg:grid-cols-3 gap-6">
                        <a v-for="post in posts" :href="route('show.post', post.slug)" class="flex-1 hover:scale-105 group transition-all rounded-lg">
                            <img :src="'/storage/posts/' + post.image" :alt="post.title" class="object-cover h-48 w-full rounded-tl-lg rounded-tr-lg grayscale group-hover:grayscale-0" />
                            <span class="w-full block text-left relative py-8">
                                <a :href="route('show.post', post.slug)"><h1 class="leading-6 text-xl font-bold text-primary-900">{{ post.title }}</h1></a>
                                <span class="text-left mt-2 leading-none text-gray-400 text-xs">
                                   {{ dateFormated(post.created_at) }}
                                </span>
                                <p class="leading-relaxed my-4" v-html="post.excerto"></p>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
 
    </front-layout>
</template>


<script>
    import { defineComponent } from 'vue'
    import FrontLayout from '@/Layouts/FrontLayout.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import JetButton from '@/Jetstream/Button.vue'
    import Icon from '@/Jetstream/Icon'

    export default defineComponent({
        components: {
            Head,
            Link,
            FrontLayout,
            JetButton,
            Icon
        },
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
            laravelVersion: String,
            phpVersion: String,
            posts: Array
        },
        data() {
            return {
            }
        },
        methods: {
            editPost(post) {
                this.$inertia.get(route('edit.post', post));
            },
            removePost(post) {
                if(confirm('Tem certeza? Esta ação é irreversível.')){
                    this.$inertia.delete(route('destroy.post', post));
                }
            },
            dateFormated(postDate) {
                let date = new Date(postDate)
                return date.toLocaleDateString()
            }
        },
    })
</script>